import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EQimaPosition, EQimaSnackbarType, QimaSnackbarService } from '@qima/ngx-qima';

const PREVIOUS_ORDER_ALREADY_LINKED_TO_RENEWAL_KEY = 'BOOKS.FOOD_CERTIFICATION.PREVIOUS_ORDER_ALREADY_LINKED_TO_RENEWAL';

@Injectable({
  providedIn: 'root',
})
export class PreviousOrderLinkedRenewalWarnService {
  public constructor(
    private readonly _translateService: TranslateService,
    private readonly _qimaSnackbarService: QimaSnackbarService
  ) {}

  /**
   * When the previous order is already linked to active renewal order(s), shows a warning snackbar.
   * @param {string} orderNumber - Previous order number (QIMA ref) being selected.
   * @param {string[] | null | undefined} linkedRenewalOrderNumbers - Active renewal order numbers from list API.
   * @returns {boolean} True when the selection must be blocked (caller should return early).
   */
  public isShowWarning(orderNumber: string, linkedRenewalOrderNumbers?: string[] | null): boolean {
    if (!orderNumber || !linkedRenewalOrderNumbers?.length) {
      return false;
    }

    this._qimaSnackbarService.open({
      message: this._translateService.instant(PREVIOUS_ORDER_ALREADY_LINKED_TO_RENEWAL_KEY, {
        orderNumber,
        linkedRenewalOrderNumbers: linkedRenewalOrderNumbers.join(', ').trim(),
      }),
      type: EQimaSnackbarType.WARNING,
      position: EQimaPosition.TOP,
      duration: 5000,
    });

    return true;
  }
}
